module.exports = __webpack_public_path__ + "img/04.559ae5f9.png";